import React, { Fragment } from 'react';
import { Calculators } from 'site-modules/shared/components/editorial/calculators/calculators';
import { ArrowLink } from 'site-modules/shared/components/arrow-link/arrow-link';

export function ResearchSharedCalculators() {
  return (
    <Fragment>
      <h2 className="heading-3 mb-1_5">Calculators</h2>
      <Calculators hasHeading={false} calculatorBoxClassName={null} />
      <ArrowLink className="my-1_5" to="/calculators/" data-tracking-id="tool_select_view">
        View all calculators
      </ArrowLink>
    </Fragment>
  );
}
